import React, { useEffect, useState, useCallback } from "react";
import { Col, Form, Input, DatePicker, Select, notification, Checkbox, InputNumber, Descriptions, Modal } from "antd";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { saveFormPromise, sendFormPromise, signCDIFormPromise } from "../../promises";
import { validateRutHelper, validateCompanyRutHelper, validateRucHelper, validateRucEntityHelper } from "../../../../helpers";
import HelloSign from 'hellosign-embedded';
import i18nextConfig from '../../../../config/i18next'
import apiConfig from "../../../../config/api";

const useFormsHooks = ({format, form, match, apiForm, setApiForm, handlerOnChangeObjAttr, initVariablesFromObject, optList}) => {
    const { t } = useTranslation('forms');
    const { getFieldDecorator, validateFields, setFieldsValue } = form;
    const [objSections, setObjSections] = useState({});

    useEffect(() => {
      if(apiForm) {
        if(match.params.view === "pdf") {
          if(apiForm.json?.lang) {
            i18nextConfig.changeLanguage(apiForm.json?.lang)
          }
        } else {
          const language = i18nextConfig.language;
          if(apiForm.json?.lang !== language) {
            if(!apiForm.json) apiForm.json = {}
            apiForm.json.lang = language
            saveFormPromiseLocal(apiForm)
          }
        }
      }
    }, [apiForm])

    const getObjSection = useCallback((objSectionId) => {
        let key = objSectionId
        let obj = objSections[objSectionId]
        if(!obj) {
            const keys = Object.keys(objSections).filter(k => objSectionId.startsWith(k))
            if(keys?.length === 1) {
                key = keys[0]
                obj = objSections[key]
            }
        }
        return [key, obj]
    });

    const registerObjSection = useCallback((objSectionId, objSection) => {
        let obj = { ...objSections, [objSectionId]: objSection };
        setObjSections(obj)
        console.log(objSectionId)
    });

    const registerObjSections = useCallback((obj) => {
      let obj2 = { ...objSections, ...obj };
      setObjSections(obj2)
    });

    const objToVariable = (variable, obj) => {
        let varAttr = { ...variable }
        for(var key in obj) {
          for(var prop in variable) {
            if(variable[prop].key === key && varAttr[prop]) {
              varAttr[prop].val = obj[key]
            }else if(typeof obj[key] === "object" && variable[prop].section === key) {
              for(var attr in obj[key]) {
                if(variable[prop].key === attr && varAttr[prop]) {
                  varAttr[prop].val = obj[key][attr]
                }
              }
            }
          }
        }
        return varAttr
    }

    const validateLengthFieldWithInnerLength = (section)=>{
        return {
          max: section.maxLength,
          message: t("messages.aml.errors.charactersLenght", {ns: 'translations', max: section.maxLength}),
        }
    }

    const setValueFinalObj = (obj, id, attr, value) => {
        const key = Object.values(obj).filter(k => k.id === id)[0]
        key[attr] = value
        return obj
    }

    const handleOnChangeFields = (obj) => {
        const keys = Object.keys(obj)
        const [key, objSection] = getObjSection(keys[0])
        //const [stateObject, stateObjectSetter] = customState(keys[0])
        
        let finalObj = { ...objSection }
        keys.map(key => {
          finalObj = setValueFinalObj(finalObj, key, 'val', obj[key] )
        })
        registerObjSection(key, finalObj)
    };

    const handleOnChangeField = (sectionId, value) => {
        const [key, obj] = getObjSection(sectionId)
        const finalObj = setValueFinalObj(obj, sectionId, 'val', value )
        registerObjSection(key, finalObj)
    };

    const handleReadOnly = (field,readOnly,sectionId=null)=>{
        if (sectionId===null){
          return null
        }else{
          const [key, obj] = getObjSection(sectionId)
          console.log(obj)
          const finalObj = setValueFinalObj(obj, sectionId, 'readOnly', readOnly )
          registerObjSection(key, finalObj)
        }
    }

    const renderFormItem = (formItem) => {
        return (
            <Col
              className={formItem.colClassName}
              span={formItem.wrapperCols}
              offset={formItem.offset}
            >
              <Form.Item
                className={formItem.itemClassName}
                label={formItem.label}
                labelCol={formItem.labelCol > 0 ? { span: formItem.labelCol } : {}}
                wrapperCol={
                  formItem.labelCol > 0 ? { span: formItem.wrapperCol } : {}
                }
              >
                {getFieldDecorator(formItem.name, {
                  rules: formItem.rules,
                  initialValue: formItem.initialValue,
                  validateTrigger: "onChange",
                })(formItem.item)}
              </Form.Item>
            </Col>
        );
    };

    const strForSearch = str => {
      return str
        ? str
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .toLowerCase()
        : str;
    };

    const renderFormItemTable = ({ section, cols=format === 'html' ? 6 : 8, offset, labelCol=0, wrapperCol=0, options=[], validator=null, customRule=null, handlerOnChangeObj=handleOnChangeField, customTitle, colsOption, colClassName, initialValue }) => {
      const optKey = optList
      ? Object.keys(optList).find(key => section.key && section.key.startsWith(key))
      : null;

      const optionsList =
        options && options.length > 0
          ? options
          : (optKey ? optList[optKey] : []);

      const display = getDisplayValue(
        section.val,
        section.type,
        optionsList
      );
      
        if (section){
          const type = section.type ?? 'input'
          const required = "required" in section ? section.required : true
          const disabled = "disabled" in section ? section.disabled : false
          const computedInitialValue = section.val && section.val !== '' && format === 'html' && type === 'date' ? moment(section.val, "DD/MM/YYYY") : format === 'pdf' && type === 'select' ? display : section.val
          return renderFormItem({
            label: customTitle ? customTitle : section.title,
            name: section.id,
            initialValue: initialValue ?? computedInitialValue,
            colClassName: colClassName ?? section.colClassName ?? 'topLabel',
            labelCol: labelCol,
            wrapperCol: wrapperCol,
            rules:
            [
              { required: required, message: t( "messages.aml.requestedField", {ns: 'translations'} ) },
              ...validator ? [{ validator: validator }]:[],
              ...(type==='input' || type==='textArea' || type==='textarea') ? [validateLengthFieldWithInnerLength(section)]:[],
              ...customRule ? [customRule]:[]
            ],
            wrapperCols: cols,
            offset: offset,
            item: (
              format === 'html' || type === 'check' ?
                type === 'input' ?
                  <Input
                    placeholder={section.placeholder ?? "Ingrese texto"}
                    autoComplete="off"
                    onFocus= {(e)=>handleReadOnly(e.target.id,false,section.id)}
                    onBlur= {(e)=>handleReadOnly(e.target.id,true,section.id)}
                    readOnly = {section.readOnly}
                    onChange={(e) => handlerOnChangeObj( section.id, e.target.value ) }
                    disabled={disabled}
                  />
                : type === 'number' ?
                  <InputNumber
                    style={{width:'100%'}}
                    placeholder={section.placeholder ?? 'Ingrese número'}
                    autoComplete="off"
                    onFocus= {(e)=>handleReadOnly(e.target.id,false,section.id)}
                    onBlur= {(e)=>handleReadOnly(e.target.id,true,section.id)}
                    min= {section.min}
                    max={section.max}
                    formatter = { section.isCurrency ? (value => `$ ${value}`)  : section.isPercentage ? (value => `${value}%`) : null}
                    readOnly = {section.readOnly}
                    onChange={(value) => {
                    handlerOnChangeObj( section.id, value )
                    }}
                    disabled={disabled}
                  />
                : type === 'textArea' ?
                  <Input.TextArea
                    placeholder={section.placeholder ?? "Ingrese texto"}
                    autoComplete="off"
                    onFocus= {(e)=>handleReadOnly(e.target.id,false,section.id)}
                    onBlur= {(e)=>handleReadOnly(e.target.id,true,section.id)}
                    readOnly = {section.readOnly}
                    onChange={(e) => handlerOnChangeObj( section.id, e.target.value ) }
                    disabled={disabled}
                    style = {{width: '100%'}}
                  />
                : type === 'select' ?
                  <Select
                    allowClear
                    showSearch
                    size={section.size}
                    optionFilterProp="children"
                    filterOption={(input, option) => {
                      if (option.props.children) {
                        return strForSearch(option.props.children).includes(
                          strForSearch(input)
                        );
                      } else {
                        return false;
                      }
                    }}
                    placeholder={section.multiple ? "Seleccione una o más opciones" : "Seleccione una opción"}
                    onChange={(value, codigo) => handlerOnChangeObj(section.id, value, null, codigo)}
                    disabled={disabled}
                    style={{ width: '100%' }}
                    mode = {section.multiple ? 'multiple' : ''}
                  >
                    { optionsList.map((option) => (<Select.Option value={option.val} key={option.key} code={option.code}>{option.text}</Select.Option>)) }
                  </Select>
                : type === 'date' ?
                  <DatePicker
                    onFocus= {(e)=>handleReadOnly(e.currentTarget.id,false,section.id)}
                    onBlur= {(e)=>handleReadOnly(e.currentTarget.id,true,section.id)}
                    readOnly = {section.readOnly}
                    format={"DD/MM/YYYY"}
                    placeholder={"Ingrese la fecha"}
                    style = {{width: '100%'}}
                    disabled={disabled}
                    mode={type}
                    onChange={(momentObj, str) => {
                      handlerOnChangeObj( section.id, momentObj ? moment(momentObj).format( "DD/MM/YYYY" ) : null )
                    }}
                  />
                : type === 'check' ?
                  <Checkbox.Group
                    style={{width: '100%'}}
                    className={section.title && section.title !== '' ? 'has-title' : ''}
                    onChange={(value) => handlerOnChangeObj(section.id, value) }
                    >
                      <hr/>
                    {options.map((option) => (
                      <Col span={colsOption ? colsOption : section.colsOption}>
                        <Checkbox value={option.val}>
                          { option.text }
                        </Checkbox>
                      </Col>
                    ))}
                  </Checkbox.Group>
                :<Input type="small"/>
              :
                <div className="pdf-field-value">
                  {display}
                </div>
            ),
          })
        }else{
          return <Col span={6}><Input disabled placeholder="SECCION NO ENVIADA"></Input></Col>
        }
    }
    
    const renderFormItemObj = (params) => {
      return renderFormItemTable({...params, handlerOnChangeObj: handlerOnChangeObjAttr})
    }

    const handleOnClear = (section) => {
      const clearFieldsById = (key, stateObj) => {
        setFieldsValue(Object.values(stateObj).reduce((acu, val) => {
          return { ...acu, [val.id]: undefined };  // Asignar undefined a los campos con ese id
        }, {}));
        let obj = {...stateObj}
        Object.values(obj).map(o => {
          o.val = undefined
        })
        registerObjSection(key, obj)
      }
      const [key, obj] = getObjSection(section)
      clearFieldsById(key, obj)
    };

    const handleDeleteAttrTable = ({attrTable, attrRecords='records', index}) => {
      return () => {
        const [keyTable, objTable] = getObjSection(attrTable)
        let obj = { ...objTable }
        const valueRecords = Object.values(obj).filter(k => k.key === attrRecords)[0]
  
        let xx = valueRecords.val;
        xx.splice(index, 1);
        registerObjSection(keyTable, obj)
  
        let formToUpdate = { ...apiForm };
        saveFormPromiseLocal(formToUpdate);
      };
    };

    const handleOnAddAttrTable = (attrObj, attrTable, attrRecords='records') => {
      const [key, obj] = getObjSection(attrObj)

      validateFields(Object.values(obj).map(v => v.id)).then((error, values) => {
        const tableOk = Object.keys(obj).reduce(
          (acc, e) => {
            return {
              ...acc,
              [obj[e].key]: obj[e].val,
            };
          },
          {}
        );
        const [key1, obj1] = getObjSection(attrTable)
        let _obj = { ...obj1 };
        const valueRecords = Object.values(_obj).filter(k => k.key === attrRecords)[0]
        valueRecords.val.push(tableOk);
        registerObjSection(key1, _obj)

        let formToUpdate = { ...apiForm };
        saveFormPromiseLocal(formToUpdate).then(ret => {
          if (ret.success) {
            handleOnClear(attrObj);
          }
        });
      }).catch(error => notification.error({ message: t("messages.aml.missingRequiredField", {ns: 'translations' }) }));
    };

    const entriesToObj = (obj) => {
      const objAttr = {}
      Object.entries(obj).map(([key, value]) => {
        if(value.section) {
          if(!objAttr[value.section]) objAttr[value.section] = {}
          objAttr[value.section][value.key] = value.val
        }else {
          objAttr[value.key] = value.val
        }
      })
      return objAttr
    }

    const saveFormPromiseLocal = async (form) => {
      let response = await saveFormPromise(form);
      if(response.code !== 'OK' && response.form !== undefined && response.form !== null) {
        setApiForm(response.form)
        initVariablesFromObject(response.form)
  
        notification["error"]({
          message: t("messages.aml.notifications.anErrorOcurred", {ns: 'translations' }),
        });
  
        return { success: false, form: response.form}
      }else {
        setApiForm(form)
        return { success: true }
      }
    }

    const emailValidator = (rule, value, callback) => {
    const regex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if (value && regex.test(value) === false) {
      callback(t("forms.errors.notValidMail", {ns: 'forms'}));
    } else {
      callback();
    }
  }

    const rutValidator = (rule, value, cb) => {
      if (value && !validateRutHelper(value)) {
        cb(t("messages.aml.notValidDoc", {ns: 'translations'}));
      }
      cb();
    };
  
    const rutValidatorCompany = (rule, value, cb) => {
      if (value && !validateCompanyRutHelper(value)) {
        cb(t("messages.aml.notValidCompanyDoc", {ns: 'translations'}));
      }
      cb();
    };
  
    const rutValidatorCompanyPerson = (rule, value, cb) => {
      if (value && !validateCompanyRutHelper(value)&&!validateRutHelper(value)) {
        cb(t("messages.aml.notValidDoc", {ns: 'translations'}));
      }
      cb();
    };
    const dniValidatorPeru = (rule, value, cb) => {
      if (value && !validateRucHelper(value)) {
        cb(t("messages.aml.notValidDoc", {ns: 'translations'}));
      }
      cb();
    };
  
    const dniValidatorCompanyPeru = (rule, value, cb) => {
      if (value && !validateRucEntityHelper(value)) {
        cb(t("messages.aml.notValidCompanyDoc", {ns: 'translations'}));
      }
      cb();
    };
  
    const dniValidatorCompanyPersonPeru = (rule, value, cb) => {
      if (value && !validateRucEntityHelper(value)&&!validateRucHelper(value)) {
        cb(t("messages.aml.notValidDoc", {ns: 'translations'}));
      }
      cb();
    };
  
    const docValidator = (tipoDocValue, type) => {
      if (tipoDocValue === "Chile-Rut"){
        if (type === 'persona') return rutValidator
        else if (type === 'empresa') return rutValidatorCompany
        else return rutValidatorCompanyPerson
      }else if(tipoDocValue === 'DNI'){
        return dniValidatorPeru
      }else if(tipoDocValue === 'RUC'){
        return dniValidatorCompanyPeru
      }
      else return null;
    };

    const toCamelCase = (str) => {
      if(str === null || str === undefined) return ''
      let s = str.replace(/\s*\([^)]*\)\s*/g, ' ');
      s = s.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      s = s.replace(/[^a-zA-Z0-9\s]/g, ' ');
      const words = s
        .trim()
        .split(/\s+/)
        .filter(w => w.length);
    
      if (words.length === 0) return '';
      return words
        .map((word, i) => {
          const w = word.toLowerCase();
          if (i === 0) return w;
          return w[0].toUpperCase() + w.slice(1);
        })
        .join('');
    };

    const getDisplayValue = (rawVal, type, options = []) => {
      // se lee type que equivale a la propiedad type del objeto "section" si no es select
      // se retorna el valor en crudo
      
      if (rawVal == null || rawVal === '' || rawVal === undefined) return '';

      if (type !== 'select') {
        return rawVal != null ? rawVal : '';
      }

      // si es select se busca en el array de options pasado como argumento
      if (Array.isArray(options) && options.length) {
        const opt = options.find(o => o.val === rawVal);
        if (opt) {
          return opt?.text
        }
      }
    
      const key = toCamelCase(rawVal);
      return t(`forms.options.${key}`, { ns: 'forms', defaultValue: rawVal });
    };
    
    
    
   const toDescriptionsPdf = (collection, stateObject, typeEntity) => {
  return (
    <>
      {collection.map((item, index) => (
        <React.Fragment key={index}>
          <div className="descriptions-pdf">
            <h4 className="descriptions-numeral">#{index + 1}</h4>
            <table size="small" className="pdf-descriptions">
              {Object.entries(stateObject).map(([fieldKey, config]) => {
                const rawValue = item[config.key];
                const matchesType =
                  (!typeEntity || !config.typeEntity || config.typeEntity.includes(typeEntity));
                if (!matchesType || ((rawValue == null || rawValue === '' || rawValue === undefined) && config.type !== 'subtitle')) {
                  return null;
                }

                let displayValue = rawValue;

                if (config.type === 'select' && optList) {
                  const optKey = Object.keys(optList).find(key =>
                    fieldKey.startsWith(key)
                  );
                  if (optKey) {
                    const option = optList[optKey].find(o => o.val === rawValue);
                    if (option) {
                      displayValue = option.text;
                    }
                  }
                }

                return (
                  <tr key={fieldKey} className="ant-descriptions-row-pdf">
                    {config.type === "subtitle" ?
                      <td colSpan={2} className="pdf-subtitle">
                        {config.title}
                      </td>
                    :
                      <>
                        <th title={config.title}>
                          {config.title}
                        </th>
                        <td>
                          {displayValue}
                        </td>
                      </>
                    }
                  </tr>
                );
              })}
            </table>
          </div>
          <br />
        </React.Fragment>
      ))}
    </>
  );
};


    const signAndSend = async (formObj, setSignData, setSigned) => {
      let record = formObj.recipient.record
        let _emails = ["no@email.com"];
  			if(record.email != null) {
  					_emails = record.email.split(",");
  			}
  			var _email = _emails[0].trim();
        let signParams = await signCDIFormPromise(formObj.id, _email)
        setSignData(signParams)
        if(signParams.embedUrl == "signed") {
          notification["warning"]({
            message: "Ya esta firmado"
          })
          setSigned(true)
          sendDocument(signParams.requestId)
        }else {
          if(signParams.embedUrl) {
            if(signParams.provider == "HELLOSIGN") {
              if(signParams.clientId != "") {
                const client = new HelloSign({
                  clientId: signParams.clientId
                });
                let testMode = !apiConfig.url.startsWith('https://api.amlupdate')
                client.open(signParams.embedUrl, {
                  testMode
                });
                client.on('sign', () => {
                  setSigned(true)
                  sendDocument(signParams.requestId)
                });
              }else {
                notification["error"]({
                  message: "Error al iniciar servicio de Firma Electronica",
                  description: signParams.message
                })
              }
            }
          } else {
            notification["error"]({
              message: "Error al iniciar servicio de Firma Electronica",
              description: signParams.message
            })
          }
        }
    }

    const sendForm = (requestId, formObj) => {
      sendFormPromise(match.params.id, requestId).then((response) => {
        if (response.code === "OK") {
          let formSend = { ...formObj, status: "SENT" };
          setApiForm(formSend);
        } else {
          notification["error"]({
            message: t("messages.aml.notifications.anErrorOcurred", {ns: 'translations' }),
            description: 'Comuníquese con soporte.aml@gesintel.cl'
          });
          setApiForm(response.form);
        }
      });
    }

    const sendDocument = (requestId = "", formObj = apiForm) => {
      if(requestId === "") {
        Modal.confirm({
          title: t("messages.aml.wantSubmitForm", {ns: 'translations' }),
          content: t("messages.aml.pressSend", {ns: 'translations' }),
          okText: t("messages.aml.send", {ns: 'translations' }),
          cancelText: t("messages.aml.cancel", {ns: 'translations' }),
          onOk() {
            sendForm(requestId, formObj);
          },
          onCancel() {},
        });
      }else {
        sendForm(requestId, formObj);
      }
    }

    return { getObjSection, 
      registerObjSection, 
      registerObjSections, 
      toCamelCase,
      handleOnChangeFields, 
      handleOnChangeField, 
      renderFormItem, 
      renderFormItemTable, 
      renderFormItemObj, 
      objToVariable, 
      handleOnClear, 
      handleDeleteAttrTable, 
      handleOnAddAttrTable, 
      entriesToObj, 
      saveFormPromiseLocal, 
      sendDocument, 
      docValidator, 
      toDescriptionsPdf, 
      signAndSend,
      emailValidator
    };

}
export default useFormsHooks;

